import { assign } from 'xstate';

import { FlowContextSme } from '../context';

const resetValues = (currentValues: FlowContextSme): FlowContextSme => {
  const data: FlowContextSme = {};

  const { hasSolarPanels } = currentValues;

  if (!hasSolarPanels) {
    data.solarPanelsOutput = undefined;
  }

  return data;
};

export const resetSolarPanelsOutput = assign(({ context, event }) => {
  if ('values' in event && event.values) {
    return { ...context, ...resetValues({ ...context, ...event.values }) };
  }

  return context;
});
